import AccountWidget from "./accountWidget.js";

export default AccountWidget;
